import React, { useState, useEffect } from 'react';
import NewGroup from './NewGroup';
import API from '../../../constants/api';
import { resToJsonHandleErrors } from '../../../helpers/actionHelpers';
import { useDispatch } from 'react-redux';
import { actionError, actionSuccess } from '../../../actions/viewActions';

const NewGroupLogic = ({ refreshGroups }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [responsable, setResponsable] = useState('');
  const [description, setDescription] = useState('');
  const [accessToClassifiedInfo, setAccessToClassifiedInfo] = useState(false);

  const [submitDisabled, setSubmitDisabled] = useState(name?.length === 0);

  const [openAccordions, setOpenAccordions] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    name?.length === 0 ? setSubmitDisabled(true) : setSubmitDisabled(false);
  }, [name]);

  const handleSubmit = (event) => {
    event.preventDefault();

    const formData = {
      name: name,
      email: email,
      responsable: responsable,
      description: description,
      accessToClassifiedInfo: accessToClassifiedInfo,
    };

    const data = new URLSearchParams(formData);
    fetch(`${API.DAM.MANAGE_GROUPS}?action=newGroupReact`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: data,
    })
      .then((res) => resToJsonHandleErrors(res))
      .then((json) => {
        dispatch(actionSuccess('groupAdded'));
        refreshGroups();
        setOpenAccordions([]);
      })
      .catch((e) => dispatch(actionError(e)));
  };

  return (
    <>
      <NewGroup
        edit={true}
        setName={setName}
        setEmail={setEmail}
        setResponsable={setResponsable}
        setDescription={setDescription}
        setAccessToClassifiedInfo={setAccessToClassifiedInfo}
        handleSubmit={handleSubmit}
        submitDisabled={submitDisabled}
        openAccordions={openAccordions}
        setOpenAccordions={setOpenAccordions}
      ></NewGroup>
    </>
  );
};

export default NewGroupLogic;
